import { Adapter as r } from "../../../../adapter.js";
import { CashbackAccountModel as c } from "./cashbackAccount.model.js";
class a extends r {
  adapt(e) {
    return new c({
      balance: e.balance,
      code: e.code,
      currency: e.currency
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  a as CashbackAccountAdapter
};
//# sourceMappingURL=cashbackAccount.adapter.js.map
